import {Component, OnInit} from '@angular/core';
import {
  ActivityModel,
  BusinessModel,
  ContactModel,
  EActivityContentType,
  EBusinessType,
  EContactFieldType,
  EContactType,
  EProjectStatus,
} from '../../@models';
import {ApiService} from '../../@core/service/api.service';
import {SidebarCommon} from '../../@core/common/sidebar';
import {Subscription} from 'rxjs';
import {NbToastrService} from '@nebular/theme';
import {ActivatedRoute, Router} from '@angular/router';
import {RegionModel} from '../../@models/region';
import {applyFilter} from '../../@core/common/filter';
import * as saveAs from 'file-saver';
import {AuthGuardService} from '../../@core/service/auth-guard.service';
import {SharedDataService} from '../../@core/service/shared-data.service';
import {FILTER_SEARCH, FILTER_STANDARD} from '../../@core/config/filter';
import {IMultiSelectOption, IMultiSelectTexts} from 'angular-2-dropdown-multiselect';

@Component({
  selector: 'ngx-companies',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss'],
  providers: [],
})

export class BusinessComponent extends SidebarCommon<BusinessModel> implements OnInit {

  public general: ContactModel;

  public potentialRange = 10000;

  public search: string;
  public searchActivities: string;

  ////////////////////////////////////////////////////////////////////////////

  ContentType = EActivityContentType;

  ////////////////////////////////////////////////////////////////////////////

  public BusinessType = EBusinessType;
  public FieldType = EContactFieldType;

  public ProjectStatus = EProjectStatus;

  ////////////////////////////////////////////////////////////////////////////
  // FILTER

  FILTER_STANDARD = FILTER_STANDARD;
  FILTER_SEARCH = FILTER_SEARCH;
  filterNameOptions: IMultiSelectOption[];

  filterNameTexts: IMultiSelectTexts = {
    defaultTitle: 'Company',
    allSelected: 'All selected',
  };

  ////////////////////////////////////////////////////////////////////////////

  isSaving = false;
  errorSubscription: Subscription;

  ////////////////////////////////////////////////////////////////////////////

  p: number = 1;

  ////////////////////////////////////////////////////////////////////////////

  showDisabled = false;

  constructor(
    private api: ApiService,
    public auth: AuthGuardService,
    public data: SharedDataService,
    private toastrService: NbToastrService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {

    this.data.loadMaterials();

    this.data.loadBusinesses().then(b => {

      const mode = this.route.snapshot.paramMap.get('mode');
      const business = this.route.snapshot.paramMap.get('business');
      if (mode != null && business != null) {
        if (mode === 'activities') {
          this.toggleSidebarActivities(b.find(x => x._id === business));
        } else {
          this.toggleSidebarDetail(b.find(x => x._id === business));
        }
      }

      this.filterNameOptions = b.map((v: BusinessModel) => {
        return { id: v._id, name: v.name};
      })
    });

    this.data.loadBusinessUnits();

    this.errorSubscription = this.api.error.subscribe(x => {
      this.isSaving = false;
    })
  }

  ////////////////////////////////////////////////////////////////////////////

  public refresh(): void {
    this.data.reloadBusinesses();
  }

  public getGeneralContact(model: BusinessModel) {
    return model.contacts.find(x => Number(x.type) === EContactType.General);
  }

  public select(model: BusinessModel) {
    this.general = this.getGeneralContact(model);
    super.select(model);
  }

  public toggleActive(item: BusinessModel) {
    item.active = !item.active;
    // this.service.saveCompanies(this.companies);
  }

  public remove(item: BusinessModel) {
    // this.companies.splice(this.companies.indexOf(item), 1);
    // this.service.saveCompanies(this.companies);
  }

  public save(item: BusinessModel) {
    if (item.manager != null && (item.manager as ContactModel).type != null) {
      item.manager = (item.manager as ContactModel)._id;
    }

    if (item.name == null || item.name.length === 0) {
      this.toastrService.danger('Name is required', 'Error');
      return;
    } else if (item.type == null ) {
      this.toastrService.danger('Type is required', 'Error');
      return;
    }
    this.isSaving = true;
    // console.log('pre save business', item)
    this.api.saveBusiness(item)
      .subscribe((i) => {
        const s = this.data.reloadBusinesses().then(b => {
          this.selected = b.find(c => c._id === i._id);
          console.log('save business', item, this.selected);
        });

        this.toastrService.success(`Business '${i.name}' update successful`, 'Saved');
        this.isSaving = false;
        // this.hideSidebar();
      });
  }

  public cancel(item: BusinessModel) {
    this.hideSidebar();
    this.router.navigate(['pages', 'business'])
  }

  public create() {
    super.create();
    this.general = null;
    this.selected.active = true;
    this.selected.contacts = [
      {type: EContactType.General, title: 'General', fields: [
          /*{type: EContactFieldType.Name, value: ''},
          {type: EContactFieldType.Street, value: ''},
          {type: EContactFieldType.Zip, value: ''},
          {type: EContactFieldType.Country, value: ''},*/
        ]},
    ];

    const defaultBu = this.data.businessUnits.find(x => x.name === 'General');
    const materialBu = this.data.businessUnits.find(x => x.name === 'Energy Materials');

    this.selected.projects = [
      /*{name: 'Documents', businessUnit: defaultBu},
      {name: 'Material Specification', businessUnit: materialBu || defaultBu},
      {name: 'Fact Sheet', businessUnit: defaultBu},*/
      {name: 'General', businessUnit: defaultBu, active: true},
      {name: 'Market Environment', businessUnit: defaultBu, active: true},
      {name: 'Competition', businessUnit: defaultBu, active: true},
      {name: 'Company information', businessUnit: defaultBu, active: true},
    ]
  }

  public toggleSidebarDetail(item: BusinessModel) {
    this.potentialRange = 10000;
    item.projects.forEach(project => {
      this.potentialRange = Math.max(this.potentialRange, project.potential || 10000);
      this.api.projectSummary(project._id).subscribe(summary => {
        project.summary = summary;
      })
    });
    super.toggleSidebarDetail(item);
  }

  private getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }


  public toggleSidebarActivities(item: BusinessModel) {
    super.toggleSidebarActivities(item);

    this.api.reloadNews(true).subscribe(activities => {
    // this.api.reloadActivities(true, { updatedAt: { $gt: moment().subtract(1, 'year').toDate() }}).subscribe(activities => {
    // this.api.reloadActivities(true).subscribe(activities => {
        // @ts-ignore

      this.selected.activities = activities.filter(x => x.business._id === this.selected._id)
        .sort((a, b) => this.getTime(new Date(b.date)) - this.getTime(new Date(a.date)))
    })
  }

  showNews(activity: string, back: string = '') {
    // this.router.navigate(['pages', 'news', activity], {queryParams: {back: 'pages/business/' + back}});
    const domain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['pages', 'news', activity], {queryParams: {back: 'pages/business/' + back}})
    );
    window.open(domain + '/#' + url, '_blank');
  }

  filter(search: string, business: BusinessModel[]) {
    const ret = this.showDisabled ? business : (business || []).filter(f => f.active);

    if (search == null || search.length === 0) return ret;
    const s = search.toLowerCase();
    let rrr =  ret.filter(x =>
      (x.name || '').toLowerCase().includes(s) ||
      x.contacts.filter(y => y.title.toLowerCase().includes(s)).length > 0 ||
      (((x.region || {}) as RegionModel).name || '').toLowerCase().includes(s) ||
      (this.BusinessType[x.type] || '').toLowerCase().includes(s));
    rrr = rrr.filter(r => (r.name || '').toLowerCase().startsWith(s))
    // console.log('rrr', search, s, rrr.map(r => r.name))
    return rrr
  }

  filterActivities(search: string, business: BusinessModel): ActivityModel[] {
    if (search == null || search.length === 0) return business.activities;
    return applyFilter<ActivityModel>(search, business.activities || [], [
      'type', 'user', 'location', 'title', 'purpose',
    ]);
  }

  filterProjects(projects) {
    return projects.filter(f => f.active);
  }

  downloadXlsx(extended = false, info = false) {
    this.api.downloadBusinesXlsx(extended, info).subscribe( data => {
      saveAs(data, info ? 'BusinessInformationOverview.xlsx' : 'BusinessList.xlsx')
    })
  }

  makeExEmployee(contact: ContactModel) {

    contact.type = EContactType.ExEmployee;
    this.save(this.selected);

  }
}